var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonFirstRightTopreact = function SvgButtonFirstRightTopreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 106.666 53.333"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1550",
    fill: "#2bd4db"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52859",
    d: "M0 53.333S1.217 3.042 53.333 0v53.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52860",
    d: "M53.333 53.333S54.55 3.042 106.666 0v53.333Z"
  }))));
};

export default SvgButtonFirstRightTopreact;